<app-multiselect-autocomplete
  [placeholder]="placeholder"
  [data]="zones"
  [myHint]="myHint"
  [disabledMultiselect]="disabledMultiselect"
  valueToSelect="zoneId"
  valueToSearch="name"
  (elementsListed)="emitElementsListed($event)"
  (result)="emitZones($event)">
</app-multiselect-autocomplete>

